import $, { ready } from 'jquery';
/* ===============================================================
Woocommerce dashboard favorites scripts
=============================================================== */
class WoocommerceFavorites {
    constructor() {
        this.favoritePage = $('.irantheme-myaccount-favorites');
        // Get wrapper wishlist
        this.wrapperList = this.favoritePage.find(
            '.irantheme-myaccount-favorites-content-list',
        );
        this.wrapperEmpty = this.favoritePage.find(
            '.irantheme-myaccount-content-empty',
        );

        this.preloader = this.favoritePage.find('.irantheme-preloader-abs');

        this.shopName = iranthemeWoo.shopName + '-wishlist';
        this.inWishlist = iranthemeWoo.inWishlist;
        this.restUrl = iranthemeWoo.restUrl;
        this.wishlist = new Array();
        this.ls = sessionStorage.getItem(this.shopName);
        this.userData = '';
        this.loggedIn = $('body').hasClass('logged-in') ? true : false;

        Array.prototype.unique = function () {
            return this.filter(function (value, index, self) {
                return self.indexOf(value) === index;
            });
        };

        $(document).on('ready', () => {
            if (this.favoritePage.length > 0) {
                this.fetchUsersData();
                this.removeItem();
                this.fetchCount();
                this.events();
            }
        });
    }

    events() {
        // Enable preloader
        this.preloader.addClass('active');
        // Append wishlist fields in page
        this.fetchItems();

        // ==========================================
        // SYNC LISTENER
        // ==========================================
        $(document).on(
            'irantheme_wishlist_updated',
            (e, newWishlist, source) => {
                this.wishlist = newWishlist;
                this.fetchCount();
                this.highlightWishlist(this.wishlist, this.inWishlist);

                // If the change came from somewhere other than the dashboard, update the dashboard page content
                if (source !== 'dashboard') {
                    this.fetchItems();
                }
            },
        );
    }

    // In your WoocommerceProducts class, add this method
    addToCartWithSpinner(button) {
        const self = this;
        const productId = $(button).data('product_id');
        const productUrl = $(button).attr('href');
        let addText = $(button).find('span');
        let spinner = $(button).find('.irantheme-animate-rotate');
        let check = $(button).find('.irantheme-icon-check');

        // Make AJAX request
        $.ajax({
            url: '/?wc-ajax=add_to_cart',
            type: 'POST',
            dataType: 'json',
            data: {
                product_id: productId,
                quantity: 1,
            },
            beforeSend: function (response) {
                $(addText).hide();
                $(spinner).show();
            },
            success: function (response) {
                $(spinner).hide();
                $(check).fadeIn();
                self.fetchCountOfCart();

                // Reset after 2 seconds
                setTimeout(() => {
                    $(check).hide();
                    $(addText).show();
                }, 2000);
            },
            error: function (xhr, status, error) {
                spinner.hide();
                button.removeClass('loading');
                addText.show();
                console.error('AJAX Error:', xhr.responseText);
                alert('خطا در افزودن به سبد خرید.');
            },
        });
    }

    // Count of cart items
    fetchCountOfCart() {
        // Get admin ajax url
        var ajax_url = iranthemeWpData.adminAjax;
        // Product fetch =============================================
        $.ajax({
            url: ajax_url,
            type: 'post',
            data: {
                action: 'fetch_count_items_from_cart',
            },
            dataType: 'html',
            beforeSend: (response) => {},
            success: (response) => {
                setTimeout(function () {
                    if (response != '0') {
                        $('.irantheme-shopping-cart-count').text(response);
                        $('.irantheme-shopping-cart-count').parent().fadeIn();
                    } else {
                        $('.irantheme-shopping-cart-count').text(response);
                        $('.irantheme-shopping-cart-count').parent().fadeOut();
                    }
                }, 1000);
            },
            complete: (response) => {},
            error: (error) => {
                console.log(error.responseText);
            },
        });
    }

    fetchUsersData() {
        let current = this;
        if (current.loggedIn) {
            // Fetch current user data
            $.ajax({
                type: 'POST',
                url: iranthemeWoo.ajaxUrl,
                data: {
                    action: 'fetch_user_data',
                    dataType: 'json',
                },
                success: function (data) {
                    current.userData = JSON.parse(data);
                    if (
                        typeof current.userData['wishlist'] != 'undefined' &&
                        current.userData['wishlist'] != null &&
                        current.userData['wishlist'] != ''
                    ) {
                        var userWishlist = current.userData['wishlist'];
                        userWishlist = userWishlist.split(',');
                        if (current.wishlist.length) {
                            current.wishlist =
                                current.wishlist.concat(userWishlist);
                            $.ajax({
                                type: 'POST',
                                url: iranthemeWoo.ajaxPost,
                                data: {
                                    action: 'user_wishlist_update',
                                    user_id: current.userData['user_id'],
                                    wishlist: current.wishlist.join(','),
                                },
                            });
                        } else {
                            current.wishlist = userWishlist;
                        }
                        current.wishlist = current.wishlist.unique();
                        current.highlightWishlist(
                            current.wishlist,
                            current.inWishlist,
                        );
                        sessionStorage.removeItem(current.shopName);
                    } else {
                        if (
                            typeof current.ls != 'undefined' &&
                            current.ls != null
                        ) {
                            current.ls = current.ls.split(',');
                            current.ls = current.ls.unique();
                            current.wishlist = current.ls;
                        }
                        $.ajax({
                            type: 'POST',
                            url: iranthemeWoo.ajaxPost,
                            data: {
                                action: 'user_wishlist_update',
                                user_id: current.userData['user_id'],
                                wishlist: current.wishlist.join(','),
                            },
                        }).done(function (response) {
                            current.highlightWishlist(
                                current.wishlist,
                                current.inWishlist,
                            );
                            sessionStorage.removeItem(current.shopName);
                        });
                    }
                },
                error: function () {
                    console.log('No user data returned');
                },
            });
        } else {
            if (typeof current.ls != 'undefined' && current.ls != null) {
                current.ls = current.ls.split(',');
                current.ls = current.ls.unique();
                current.wishlist = current.ls;
            }
        }
    }

    isInArray(value, array) {
        return array.indexOf(value) > -1;
    }

    onWishlistComplete(target, title) {
        setTimeout(function () {
            target
                .removeClass('loading')
                .addClass('active')
                .attr('title', title);
        }, 50);
    }

    highlightWishlist(wishlist, title) {
        let current = this;
        $(document)
            .find('.wishlist-toggle')
            .each(function () {
                var $this = $(this);
                var currentProduct = $this.data('product');
                currentProduct = currentProduct.toString();
                if (current.isInArray(currentProduct, wishlist)) {
                    $this.addClass('active').attr('title', title);
                } else {
                    $this.removeClass('active').removeAttr('title');
                }
            });
    }

    // Fetch wishlist items
    fetchItems() {
        let current = this;
        if (iranthemeWoo.woocommerceIsActivate == 1) {
            setTimeout(function () {
                if (current.wishlist.length) {
                    // Get admin ajax url
                    var ajax_url = iranthemeWpData.adminAjax;
                    $.ajax({
                        url: ajax_url,
                        type: 'post',
                        data: {
                            action: 'wishlist_list_items_wc_favorites',
                            wishlist_ids: current.wishlist.join(','),
                        },
                        dataType: 'html',
                        beforeSend: () => {
                            current.wrapperEmpty.addClass('d-none');
                            // Empty wrapper list
                            current.wrapperList.html('');
                            current.preloader.addClass('active');
                        },
                        success: (response) => {
                            $(
                                '.irantheme-myaccount-favorites-content-list',
                            ).html(response);
                        },
                        complete: (response) => {
                            current.preloader.removeClass('active');
                            // Shopping bag icon click
                            $(
                                '.irantheme-myaccount-favorites-content-list-item-action-add-to-cart .favorite_ajax_add_to_cart',
                            ).on('click', (e) => {
                                e.preventDefault();
                                current.addToCartWithSpinner(
                                    $(e.currentTarget),
                                );
                            });
                        },
                        error: (error) => {
                            console.log(error.responseText);
                        },
                    });
                } else {
                    // Empty wrapper list
                    current.wrapperList.html('');
                    current.wrapperEmpty.removeClass('d-none');

                    current.preloader.removeClass('active');
                }
                $('.irantheme-myaccount-favorites-content-list').each(
                    function () {
                        $(this).removeClass('loading');
                    },
                );
            }, 1000);
        } else {
            // Empty wrapper list
            current.wrapperList.html('');
            let emptyTag =
                '<div class="irantheme-myaccount-favorites-content-empty"><i class="fa-duotone fa-light fa-clipboard-list irantheme-myaccount-favorites-content-empty-icon"></i><h5 class="irantheme-myaccount-favorites-content-empty-title">متاسفانه افزونه ووکامرس فعال یا نصب نمی باشد.</h5></div>';
            $(emptyTag).prependTo(current.wrapperList);
            current.preloader.removeClass('active');
        }
    }

    // Count of wishlist items
    fetchCount() {
        let current = this;
        if (iranthemeWoo.woocommerceIsActivate == 1) {
            setTimeout(function () {
                if (current.wishlist.length) {
                    $('.irantheme-wishlist-count').text(
                        current.wishlist.length,
                    );
                    // $('.irantheme-wishlist-count').parent().fadeIn();
                } else {
                    $('.irantheme-wishlist-count').text(
                        current.wishlist.length,
                    );
                    // $('.irantheme-wishlist-count').parent().fadeOut();
                }
            }, 1000);
        }
    }

    // Remove item from wishlist
    removeItem() {
        let current = this;
        $(document).on('click', '.wc-favorite-wishlist-remove', function () {
            // Enable preloader
            current.preloader.addClass('active');
            var $this = $(this);
            current.wishlist = [];
            $this
                .closest('.irantheme-myaccount-favorites-content-list')
                .find('.irantheme-myaccount-favorites-content-list-item')
                .each(function () {
                    if (
                        $(this).data('product') !=
                        $this
                            .closest(
                                '.irantheme-myaccount-favorites-content-list-item',
                            )
                            .data('product')
                    ) {
                        current.wishlist.push($(this).data('product'));
                    }
                });
            if (current.loggedIn) {
                // get user ID
                if (current.userData['user_id']) {
                    $.ajax({
                        type: 'POST',
                        url: iranthemeWoo.ajaxPost,
                        data: {
                            action: 'user_wishlist_update',
                            user_id: current.userData['user_id'],
                            wishlist: current.wishlist.join(','),
                        },
                    })
                        .done(function (response) {
                            $this
                                .closest(
                                    '.irantheme-myaccount-favorites-content-list-item',
                                )
                                .remove();
                            // SYNC TRIGGER
                            $(document).trigger('irantheme_wishlist_updated', [
                                current.wishlist,
                                'dashboard',
                            ]);
                        })
                        .fail(function (response) {
                            console.log(response.responseText);
                        })
                        .always(function (data) {
                            current.fetchCount();
                        });
                }
            } else {
                sessionStorage.setItem(
                    current.shopName,
                    current.wishlist.toString(),
                );
                setTimeout(function () {
                    $this
                        .closest(
                            '.irantheme-myaccount-favorites-content-list-item',
                        )
                        .remove();
                    // SYNC TRIGGER
                    $(document).trigger('irantheme_wishlist_updated', [
                        current.wishlist,
                        'dashboard',
                    ]);
                }, 500);
            }
            setTimeout(() => {
                // Disable preloader
                current.preloader.removeClass('active');
                if (current.wishlist.length == 0) {
                    // Empty wrapper list
                    current.wrapperList.html('');
                    current.wrapperEmpty.removeClass('d-none');
                }
            }, 501);
        });
    }
}

export default WoocommerceFavorites;
